import React from 'react'
import { InputTextarea } from 'primereact/inputtextarea'
import './../form.scss'
import { PropsType } from '../../../models/util'

interface TextAreaProps extends PropsType {
    onChangeCallback: (e: any) => void // on change callback
    value: string // input value

    // to override primereact and/or wardrobe styles, use custom classes
    classes?: string // css classes for the element
    containerClasses?: string // css classes for the <div> container
    style?: any

    mandatory?: boolean // adds * in labels (TODO validation message)
    clearable?: boolean // add 'x' icon to clear the field
    disabled?: boolean // if true the element is disabled
    colWidth?: number | string // set element width from 1 to 12 columns (default: 12)

    label?: string // label
    floatingLabel?: boolean // floating labels appear only when the field is filled in
    placeholder?: string // placeholder

    additionalProps?: any // pass props for the Prime React original component

    // TODO icons
}

const TextArea = (props: TextAreaProps) => {
    const {
        onChangeCallback,
        value,
        placeholder,
        classes,
        style,
        mandatory,
        colWidth,
        disabled,
        containerClasses,
        floatingLabel,
        label,
    } = props

    return (
        <div
            className={`wardrobe-form-input p-col-${
                colWidth ? colWidth : '12'
            } ${containerClasses ? containerClasses : ''} ${
                label ? 'labeled-input' : ''
            }`}>
            <InputTextarea
                value={value}
                disabled={disabled}
                rows={5}
                cols={10}
                onChange={(e) => onChangeCallback(e.target.value)}
                placeholder={String(placeholder)}
                className={`${classes} w-100`}
                style={style}
            />
            {label && (
                <label className={`${floatingLabel && !value ? 'empty' : ''}`}>
                    {`${label}${mandatory ? ' *' : ''}`}
                </label>
            )}
        </div>
    )
}

export default TextArea
